import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/MobileMenu.css';

const Header = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuContainerRef = useRef(null);
  const location = useLocation();

  // Close mobile menu on route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Close menu on clicks outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(e.target)) {
        setMobileMenuOpen(false);
      }
    };

    if (mobileMenuOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('touchstart', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [mobileMenuOpen]);

  const handleLogout = () => {
    setMobileMenuOpen(false);
    setIsLoggingOut(true);
    setTimeout(() => {
      logout();
      setIsLoggingOut(false);
    }, 1500); // 1.5 second delay for animation
  };

  return (
    <>
      {isLoggingOut && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(5px)',
          }}
        >
          <div
            className="spinner"
            style={{
              width: '50px',
              height: '50px',
              borderWidth: '5px',
              borderColor: 'rgba(255, 22, 22, 0.2)',
              borderTopColor: '#ff1616',
              marginBottom: '20px',
            }}
          ></div>
          <h2
            style={{
              color: '#333',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '24px',
              fontWeight: '600',
            }}
          >
            Loggar ut...
          </h2>
        </div>
      )}
      <div
        ref={menuContainerRef}
        data-animation="default"
        data-collapse="small"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navbar w-nav"
      >
        <div className="container-2 w-container">
          <Link to="/" className="brand w-nav-brand" onClick={() => setMobileMenuOpen(false)}>
            <img
              loading="lazy"
              src="/images/SWEDEN_nobg.png"
              alt="Logo of TrafikBevakning one the homepage of the site"
              className="image-4"
            />
          </Link>
          <nav
            role="navigation"
            className={`w-nav-menu ${mobileMenuOpen ? 'w--open' : ''}`}
            data-nav-menu-open={mobileMenuOpen ? '' : undefined}
          >
            {isAuthenticated ? (
              <>
                <Link to="/plans" className="w-nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Priser
                </Link>
                <Link to="/bokning" className="w-nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Bokningsassistent
                </Link>
                <Link to="/account" className="w-nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Mitt Konto
                </Link>
                <button
                  onClick={handleLogout}
                  className="w-nav-link"
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  Logga ut
                </button>
              </>
            ) : (
              <>
                <Link to="/plans" className="w-nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Priser
                </Link>
                <Link to="/login" className="w-nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Logga in
                </Link>
                <Link
                  to="/register"
                  className="w-nav-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Skapa Konto
                </Link>
              </>
            )}
          </nav>
          <button
            type="button"
            className={`menu-button w-nav-button ${mobileMenuOpen ? 'w--open' : ''}`}
            aria-label="Öppna meny"
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <div className="w-icon-nav-menu"></div>
          </button>
        </div>
      </div>
      <section className="gpt-global-nav-wrapper">
        <Link to="/" className="w-inline-block">
          <img
            loading="lazy"
            src="/images/SWEDEN_nobg.png"
            alt="Logo of TrafikBevakning one the homepage of the site"
          />
        </Link>
        <div className="gpt-nav-button">
          {isAuthenticated ? (
            <>
              <Link to="/plans" className="gpt-nav-link">
                Priser
              </Link>
              <Link to="/bokning" className="gpt-nav-link">
                Bokningsassistent
              </Link>
              <Link to="/account" className="gpt-nav-link">
                {user?.name || user?.email}
              </Link>
              <button
                onClick={handleLogout}
                className="gpt-nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Logga ut
              </button>
            </>
          ) : (
            <>
              <Link to="/plans" className="gpt-nav-link">
                Priser
              </Link>
              <Link to="/login" className="gpt-nav-link">
                Logga in
              </Link>
              <Link to="/register" className="gpt-nav-link">
                Skapa Konto
              </Link>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default Header;
